import axios from 'axios';

// Call the same-origin nginx proxy on admin.autovertest.com
const API_BASE = '/api/saas';

export const fetchFestivals = async (search = '') => {
  const params = search ? { search } : {};
  const res = await axios.get(`${API_BASE}/festivals`, { params });
  return res.data;
};

export const toggleFestivalSaaS = async (eventId, isEnabled) => {
  const res = await axios.put(`${API_BASE}/festivals/${eventId}/toggle-saas`, { isEnabled });
  return res.data;
};

export const fetchFestivalArchitecture = async (eventId) => {
  const res = await axios.get(`${API_BASE}/festivals/${eventId}/architecture`);
  return res.data;
};

export const toggleFestivalModule = async (eventId, moduleId, isEnabled) => {
  const res = await axios.post(`${API_BASE}/festivals/${eventId}/modules/${moduleId}/toggle`, { isEnabled });
  return res.data;
};

export const updateGroupPermissionMatrix = async (eventId, moduleId, groupKey, permissionShortKeys) => {
  const res = await axios.put(`${API_BASE}/festivals/${eventId}/modules/${moduleId}/matrix`, {
    groupKey,
    permissionShortKeys,
  });
  return res.data;
};

export const updateFestivalSettings = async (eventId, settings) => {
  const res = await axios.put(`${API_BASE}/festivals/${eventId}/settings`, settings);
  return res.data;
};

export const getFestivalLaunchToken = async (eventId) => {
  const res = await axios.post(`${API_BASE}/festivals/${eventId}/launch-token`);
  return res.data;
};
